import React from "react";
// import { UserContext } from "./hooks/UserContext";
import './App.css';
import Router from './Route/index';

export default function App(){
 // const classes = useStyles();
 //localStorage.removeItem("userData");
 //console.log(process.env.REACT_APP_BASEAPI_URL)
    return (
      <div>
        <Router />
      {/* <BrowserRouter>
      <Switch>

          <PublicRoute restricted={true} exact path='/Login' component={Login} />
          <PrivateRoute exact path='/' component={dash} />
          <PrivateRoute exact path='/dashboards' component={dash} />
          <PrivateRoute exact path='/user' component={User} />
          <PrivateRoute exact path='/trip' component={Destination} />
          <PrivateRoute exact path='/trip/create' component={AddDestination} />
          <PrivateRoute exact path='/admin/profile' component={MyProfile} />
          <PrivateRoute component={NotFound}/>
        </Switch>
      </BrowserRouter> */}
      </div>
      
      
    );
}




// WEBPACK FOOTER //
// ./src/App.js